import sk from "./sk.json"

export const messages = {
    sk: sk
}